app.directive('elementReady', ['$parse', '$timeout', function ($parse, $timeout) {
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {

            var loadTimeout,
                fnSuccess = $parse(attrs.elementReadySuccess),
                fnFail = $parse(attrs.elementReadyFail);

            element.on('load', function () {
                $scope.$apply(function () {
                    $timeout.cancel(loadTimeout);
                    return fnSuccess($scope);
                })
            });

            loadTimeout = $timeout(function () {
                element.off('load');
                $timeout.cancel(loadTimeout);
                $scope.$apply(function () {
                    return fnFail($scope);
                })
            }, 60000);

        }
    }
}]);